import React, { Component } from "react";
import PropTypes from "prop-types";
import { GUIDES_TAB_HEADER_COLOR, GUIDES_TITLE_NAME } from "../../../helpers/constants";
import glasses from "../../../assets/images/guides/glasses.png";
import GuidesHeader from "../../../components/molecules/GuidesHeader";
import { fetchGhostPostBySlug } from "../../../helpers/ghost";
import StyledLoading from "../../../components/atoms/Loading/StyledLoading";
import urlPatterns from "../../../urls";
import { header } from "../../../styles/variables";
import GuidesTabNavigator from "../../../components/molecules/GuidesTabNavigator";
import GuidesDetailMain from "../../../components/molecules/GuidesTabPages/GuidesDetailMain";

class GuidesGrapeTypeDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      post: null,
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    const { params } = match || {};
    const { slug } = params || {};
    if (slug) {
      const post = await fetchGhostPostBySlug(slug);
      this.setState({ post, loading: false });
    }
  }

  render() {
    const { match, location } = this.props;
    const { post, loading } = this.state;

    if (loading) return <StyledLoading />;

    const { title } = post || {};

    const { url } = match || {};

    return (
      <>
        <GuidesHeader
          headerIcon={glasses}
          headerColor={GUIDES_TAB_HEADER_COLOR.GUIDE_GRAPE_COLOR}
          headerTitle={title || GUIDES_TITLE_NAME.GUIDE_GRAPE_COLOR}
        />
        <GuidesTabNavigator
          mobileHeaderStyleTop={header.mobileHeight}
          shouldDisappearOnMobile
          backgroundColor={GUIDES_TAB_HEADER_COLOR.GUIDE_GRAPE_COLOR}
          urlGrapeType={url}
          location={location}
        />
        <GuidesDetailMain
          post={post}
          parentLabel="Grape Varieties"
          parentUrl={urlPatterns.GUIDE_GRAPE_COLOR}
          isFromTabGrape
          location={location}
        />
      </>
    );
  }
}

GuidesGrapeTypeDetails.propTypes = {
  match: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesGrapeTypeDetails;
